export default __webpack_public_path__ + "static/media/monetary_chart.fcefad6a.svg";